import { defu } from 'defu'
import { ALL_LOB } from '~/constants'
import { useWorkspace } from '~/stores/workspace'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const connectorId = (to.query.lob as string) || ''
  const currentUser = useCurrentUser()
  const workspace = useWorkspace()
  const { setUrlParams, activeUrlParams } = useUrlParamsState()

  if (!import.meta.client) {
    return
  }

  if (connectorId && !workspace.connectorId) {
    setUrlParams('lob', connectorId)
    history.replaceState(
      { query: { ...activeUrlParams, lob: workspace.connectorId } },
      to.path,
    )
    workspace.$patch({
      connectorId,

      previousConnectorId: '',
    })
  }

  if (connectorId && connectorId !== workspace.connectorId) {
    await workspace.findAndSetConnector(connectorId, {
      force: true,
      middleware: true,
    })
    return
  }

  // Allow ALL_LOB for exclusions page to support nested table functionality
  const isExclusionsPage =
    to.path.startsWith('/exclusions') ||
    to.path.startsWith('/dashboard/exclusions')
  if (
    !isExclusionsPage &&
    (workspace.connectorId === ALL_LOB || !workspace.connectorId)
  ) {
    await workspace.findAndSetConnector(workspace.previousConnectorId, {
      middleware: true,
    })
  }

  if (
    workspace.underMaintenance &&
    !guard(
      'ANY',
      [PERMISSIONS.readSystem, PERMISSIONS.writeSystem],
      workspace.userPermissions,
    )
  ) {
    return navigateTo({ path: '/account' }, { replace: true })
  }

  if (!connectorId && workspace.connectorId) {
    // For exclusions page with ALL_LOB, set lob parameter to all_lob
    if (isExclusionsPage && workspace.connectorId === ALL_LOB) {
      const query = defu({ lob: ALL_LOB, ...activeUrlParams }, to.query)
      setUrlParams('lob', ALL_LOB)
      // Only navigate if the query params are different to avoid infinite loop
      if (to.query.lob !== ALL_LOB) {
        return navigateTo({ path: to.path, query })
      }
      return
    }

    const query = defu(
      { lob: workspace.connectorId, ...activeUrlParams },
      to.query,
    )

    setUrlParams('lob', workspace.connectorId)

    // Only navigate if the query params are different to avoid infinite loop
    if (to.query.lob !== workspace.connectorId) {
      return navigateTo({ path: to.path, query })
    }
    return
  }

  if (!currentUser.value?.connectors) {
    await workspace.waitForReady()
    if (!workspace.user) {
      return navigateTo({ path: '/auth/login' }, { replace: true })
    }
    return navigateTo({ path: '/account', query: to.query }, { replace: true })
  }
})
